import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { NotificationManager } from '../../../components/common/react-notifications';
import { 
  EVALUATION_ROLE_LIST,
  EVALUATION_ROLE_ADD,
  EVALUATION_ROLE_DETAIL,
  EVALUATION_ROLE_UPDATE
} from '../../actions';

import {
  EvaluationRoleListSuccess,
  EvaluationRoleListError,
  EvaluationRoleAddSuccess,
  EvaluationRoleAddError,
  EvaluationRoleDetailSuccess,
  EvaluationRoleDetailError,
  EvaluationRoleUpdateSuccess,
  EvaluationRoleUpdateError
} from '../../actions';
 
export function* watchEvaluationRoleList() {
  yield takeEvery(EVALUATION_ROLE_LIST, onEvaluationRoleList);
}

export function* watchEvaluationRoleAdd() {
  yield takeEvery(EVALUATION_ROLE_ADD, onEvaluationRoleAdd);
}

export function* watchEvaluationRoleDetail() {
  yield takeEvery(EVALUATION_ROLE_DETAIL, onEvaluationRoleDetail);
}

export function* watchEvaluationRoleUpdate() {
  yield takeEvery(EVALUATION_ROLE_UPDATE, onEvaluationRoleUpdate);
}

const onEvaluationRoleListAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_role/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

const onEvaluationRoleUpdateAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_role/update', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => {
        unsubscribe();
        resolve(token);
      });
    }, reject);
  });
}

const onEvaluationRoleAddAsync = async (data) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_role/add', {
      method: 'POST', mode: 'cors', cache: 'no-cache',
      headers: { 'Content-Type': 'application/json', 'token': token },
      body: JSON.stringify(data.payload)
  })
      .then(response => response.json())
      .then(data => { return data; })
      .catch(err => console.log(err));
  return { message: true, data: response };
};

const onEvaluationRoleDetailAsync  = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'assessment/evaluation_role/detail', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  })
    .then(response => response.json())
    .then(data => { return data; })
    .catch(err => console.log(err));
  return { "data": response };
};

function* onEvaluationRoleList(data) {
  try {
    const response = yield call(onEvaluationRoleListAsync, data.payload);
    yield put(EvaluationRoleListSuccess(response.data));
  } catch (error) {
    yield put(EvaluationRoleListError(error));
  }
}

function* onEvaluationRoleAdd(data) {
  try {
      const response = yield call(onEvaluationRoleAddAsync, data);
      console.log(response)
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationRoleAddSuccess(response.data));
  } catch (error) {
      yield put(EvaluationRoleAddError(error));
      NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
  }
}

function* onEvaluationRoleDetail(data) {
  try {
    const response = yield call(onEvaluationRoleDetailAsync, data.payload);
    yield put(EvaluationRoleDetailSuccess(response.data.data));
  } catch (error) {
    yield put(EvaluationRoleDetailError(error));
  }
}

function* onEvaluationRoleUpdate(data) {
  try {
      const response = yield call(onEvaluationRoleUpdateAsync, data.payload);
      if (response.data.status === true) {
          NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
      } else if (response.data.status === 'error') {
          NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
      }
      yield put(EvaluationRoleUpdateSuccess(response.data));
  } catch (error) {
      yield put(EvaluationRoleUpdateError(error));
  }
}

export default function* rootSaga() {
  yield all([
    fork(watchEvaluationRoleList),
    fork(watchEvaluationRoleAdd),
    fork(watchEvaluationRoleDetail),
    fork(watchEvaluationRoleUpdate),
  ]);
} 